"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { cn } from "@/lib/utils";
import {
    BORDER_RADIUS_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";
import { ImageZoom } from "@/components/render/imagezoom";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
    theme: IUserData["chosen_theme"];
}
const getCols = (itemCount: number) => {
    switch (itemCount) {
        case 1:
            return "columns-1";
        case 2:
            return "columns-2";
        case 3:
            return "columns-3";
        case 4:
            return "columns-4";
        case 5:
            return "columns-5";
        case 6:
            return "columns-6";
        case 7:
            return "columns-7";
        case 8:
            return "columns-8";
        case 9:
            return "columns-9";
        case 10:
            return "columns-10";
        default:
            return "columns-1";
    }
};

export default function BlockGallery({ edit, block, update, theme }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    const images: Array<{
        image: string;
        url?: string;
    }> = blockUpdate.options.images;
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`Gallery`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                id="gallery"
                className={cn(
                    "w-full gap-1",
                    getCols(blockUpdate.options.grid_size),
                    "block-" + block.id
                )}
            >
                {images.map((item, index) => (
                    <ImageZoom key={index} zoomMargin={100}>
                        <img
                            src={item.image}
                            className={cn(
                                `mx-auto mb-1 inline-block w-full rounded-xl`,
                                BORDER_RADIUS_OPTIONS[
                                    theme.profile.design.corner_radius
                                ]?.class,
                                SHADOW_OPTIONS[theme.profile.design.shadow]
                                    ?.class,
                                blockUpdate.style?.custom &&
                                    BORDER_RADIUS_OPTIONS[
                                        blockUpdate.style.corner_radius
                                    ]?.class,
                                blockUpdate.style?.custom &&
                                    SHADOW_OPTIONS[blockUpdate.style.shadow]
                                        ?.class
                            )}
                            alt={item.image}
                        />
                    </ImageZoom>
                ))}
            </div>
        </AdminPopover>
    );
}
